import { arrayRemove, arrayUnion, query, serverTimestamp, setDoc, updateDoc, where, } from "firebase/firestore";
import { asManagedProfileId, err, newId, ok, } from "@pack-it-up/shared";
import { toDomainManagedProfile } from "../mappers/index.js";
import { observeQuery, patchField, toDomainError } from "./support.js";
import { callFn } from "./callable.js";
export const makeManagedProfileRepo = (db, p, session, functions) => ({
    observeMyManagedProfiles: (userId) => observeQuery(query(p.managedProfiles(), where("guardianUserIds", "array-contains", userId)), toDomainManagedProfile, "managedProfiles"),
    async createManagedProfile(input) {
        const u = session.user();
        if (!u)
            return err(toDomainError({ code: "permission-denied" }));
        try {
            const id = newId();
            await setDoc(p.managedProfile(id), {
                id,
                displayName: input.displayName,
                guardianUserIds: [u.id],
                createdAt: serverTimestamp(),
            });
            return ok(asManagedProfileId(id));
        }
        catch (e) {
            return err(toDomainError(e));
        }
    },
    async updateManagedProfile(patch) {
        const out = {};
        patchField(out, "displayName", patch.displayName);
        patchField(out, "photoUrl", patch.photoUrl);
        try {
            await updateDoc(p.managedProfile(patch.id), out);
            return ok(undefined);
        }
        catch (e) {
            return err(toDomainError(e));
        }
    },
    async addGuardian(profileId, friendUserId) {
        try {
            await updateDoc(p.managedProfile(profileId), { guardianUserIds: arrayUnion(friendUserId) });
            return ok(undefined);
        }
        catch (e) {
            return err(toDomainError(e));
        }
    },
    async removeGuardian(profileId, userId) {
        try {
            await updateDoc(p.managedProfile(profileId), { guardianUserIds: arrayRemove(userId) });
            return ok(undefined);
        }
        catch (e) {
            return err(toDomainError(e));
        }
    },
    // The id-swap fan-out across trips/completions needs server privilege — a Cloud
    // Function that resolves the target account by email then rewrites every reference (T12).
    async upgradeToAccount(profileId, email) {
        const r = await callFn(functions, "upgradeManagedProfile", { profileId, email });
        return r.ok ? ok(undefined) : r;
    },
});
//# sourceMappingURL=managedProfile.repo.js.map